export const reviewfilter = [
  { name: "추천순", slug: "highVote" },
  { name: "웜톤 리뷰", slug: "warmColor" },
  { name: "쿨톤 리뷰", slug: "coolColor" },
];
